import React from "react";
import "./Loader.css";
import { Scrollx_animate } from "../../assets/icons";

export default function Loader({ label }) {
  return (
    <div
      style={{
        zIndex: 999,
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        backgroundImage: "linear-gradient(90deg , #2f3034, #3b3d49)",
        // backgroundColor: "var(--darkblue-50)",
        // opacity: "0.95",
        borderRadius: "1rem",
        padding: "1rem",
        border: "1px solid white",
      }}
    >
      <img
        src={Scrollx_animate}
        alt="scrollx"
        className="scrollxImg relative"
        style={{ margin: "auto" }}
        height="120px"
        width="120px"
      />
      <div
        className="flex justify-center"
        style={{ fontSize: "15px", color: "var(--yellow-50)" }}
      >
        {label}
      </div>
    </div>
  );
}
